import { motion } from "framer-motion";
import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { staggerContainer, staggerItem } from "@/lib/motion";
import { proof } from "@/spiel/proof";
import styles from "./Proof.module.scss";

export const Proof = () => (
  <Section id="work">
    <Container>
      <Reveal>
        <p className={styles.label}>{proof.heading}</p>
      </Reveal>

      <motion.div
        className={styles.grid}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={staggerContainer}
      >
        {proof.stats.map((stat) => (
          <motion.div
            key={`${stat.value}-${stat.label}`}
            className={styles.stat}
            variants={staggerItem}
          >
            <span className={styles.value}>{stat.value}</span>
            <span className={styles.statLabel}>{stat.label}</span>
            {stat.detail && (
              <span className={styles.detail}>{stat.detail}</span>
            )}
          </motion.div>
        ))}
      </motion.div>

      {proof.flagship && (
        <Reveal>
          <article className={styles.flagship}>
            {proof.flagship.href ? (
              <a href={proof.flagship.href} className={styles.flagshipName}>
                {proof.flagship.name}
              </a>
            ) : (
              <h3 className={styles.flagshipName}>{proof.flagship.name}</h3>
            )}

            <p className={styles.flagshipDescription}>
              {proof.flagship.description}
            </p>

            {proof.flagship.outcome && (
              <p className={styles.flagshipOutcome}>{proof.flagship.outcome}</p>
            )}

            <p className={styles.flagshipOwned}>{proof.flagship.owned}</p>
          </article>
        </Reveal>
      )}

      {proof.range.length > 0 && (
        <>
          <Reveal>
            <p className={styles.rangeLabel}>{proof.rangeLabel}</p>
          </Reveal>

          <motion.div
            className={styles.range}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            variants={staggerContainer}
          >
            {proof.range.map((work) => (
              <motion.div
                key={work.name}
                className={styles.work}
                variants={staggerItem}
              >
                <h4 className={styles.workName}>{work.name}</h4>
                <p className={styles.workSummary}>{work.summary}</p>
              </motion.div>
            ))}
          </motion.div>
        </>
      )}
    </Container>
  </Section>
);
